import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, post, put } from "./apiService";
import {
  ITriageQueueState,
  ITriageUserState,
} from "../models/triageQueueInterface";
import {
  URL_APPROVE_TRIAGE_QUEUE_MESSAGE,
  URL_DASHBOARD_INDIV,
  URL_FETCH_TRIAGE_PROFILE_PIC,
  URL_FETCH_TRIAGE_MESSAGE_COUNT,
  URL_FETCH_TRIAGE_QUEUE_MESSAGE,
} from "../config/apiUrls";
import { IFetchProfilePic } from "../models/dashboardInterfaces";

// to fetch all associate
export const fetchTriageQueueList = createAsyncThunk(
  "triageQueueDataSlice/fetchTriageQueueList",
  async (form: ITriageQueueState, thunkAPI) => {
    try {
      const { page, ...body } = form;
      let url = URL_FETCH_TRIAGE_QUEUE_MESSAGE;
      if (page !== 0) {
        url = url + "?page=" + page;
      }
      const response = post(url, body);
      return (await response).data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchTriageProfilePic = createAsyncThunk(
  "triageQueueDataSlice/fetchTriageProfilePic",
  async (form: IFetchProfilePic, thunkAPI) => {
    try {
      const url = URL_FETCH_TRIAGE_PROFILE_PIC;
      const response = post(url, form);
      return (await response).data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchTriageUserList = createAsyncThunk(
  "triageQueueDataSlice/fetchTriageUserList",
  async (params: { triage_id: number; form: ITriageUserState }, thunkAPI) => {
    try {
      const response = post(URL_DASHBOARD_INDIV, params.form);
      return { id: params.triage_id, users: (await response).data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// //to fetch Triage Notification count
export const fetchTriageNotificationcount = createAsyncThunk(
  "triageQueueDataSlice/fetchTriageNotificationcount",
  async (form: ITriageQueueState, thunkAPI) => {
    try {
      const url = URL_FETCH_TRIAGE_MESSAGE_COUNT;
      const response = get(url, form);
      return (await response).data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//to update updatemessageTemplateData user
export const approveTriageQueueMessage = createAsyncThunk(
  "triageQueueDataSlice/approveTriageQueueMessage",
  async (form: ITriageQueueState, thunkAPI) => {
    try {
      const response = put(URL_APPROVE_TRIAGE_QUEUE_MESSAGE, form);
      return (await response).data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// //to update updatemessageTemplateData user
// export const deletemessageTemplateData = createAsyncThunk(
//   'triageQueueDataSlice/deletemessageTemplateData',
//   async (form: IMessageTemplateState, thunkAPI) => {
//     try {
//       const response = deleteApi(URL_DELETE_MESSAGE_TEMPLATE, form);
//       return (await response).data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );
